import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const DivisionForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'division'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'division.general.division_name_label',
            type: 'text',
            placeholder: 'division.general.division_name_placeholder',
        },
        {
            name: 'company_logo',
            label: 'company_details.general.company_logo_label',
            type: 'image',
            alignment: 'stacked',
            imageType: 'landscape',
            dropzoneText: 'company_details.general.company_logo_placeholder',
            apiField: {
                fileUpload: 'company_logo_file',
                fileName: 'company_logo_filename',
                imageDeleted: 'company_logo_image_deleted'
            },
            helperText: 'company_details.general.company_logo_helperText',
        },
        {
            type: 'header',
            header: 'company_details.general.address_header'
        },
        {
            type: 'text',
            name: 'street',
            label: 'company_details.general.street_label',
            placeholder: 'company_details.general.street_placeholder',
            width: '70%',
            group: 'field-row',
        },
        {
            type: 'text',
            name: 'house_number',
            label: 'company_details.general.house_number_label',
            placeholder: 'company_details.general.house_number_placeholder',
            width: '30%',
            group: 'field-row',
        },
        {
            type: 'text',
            name: 'postal_code',
            label: 'company_details.general.postal_code_label',
            placeholder: 'company_details.general.postal_code_placeholder',
            width: '40%',
            group: 'field-row-next',
        },
        {
            type: 'text',
            name: 'city',
            label: 'company_details.general.city_label',
            placeholder: 'company_details.general.city_placeholder',
            width: '60%',
            group: 'field-row-next',
        },
        {
            type: 'text',
            name: 'country',
            label: 'company_details.general.country_label',
            placeholder: 'company_details.general.country_placeholder',
        },
        {
            type: 'header',
            header: 'company_details.general.contact_information_header'
        },
        {
            type: 'email',
            name: 'email',
            label: 'company_details.general.email_label',
            placeholder: 'company_details.general.email_placeholder',
        },
        {
            type: 'text',
            name: 'phone_number',
            label: 'company_details.general.phone_number_label',
            placeholder: 'company_details.general.phone_number_placeholder',
        },
        {
            type: 'text',
            name: 'website',
            label: 'company_details.general.website_label',
            placeholder: 'company_details.general.website_placeholder',
        },
        {
            type: 'header',
            header: 'company_details.general.financial_details_header'
        },
        {
            type: 'text',
            name: 'coc_number',
            label: 'company_details.general.kvk_number_label',
            placeholder: 'company_details.general.kvk_number_placeholder',
        },
        {
            type: 'text',
            name: 'vat_number',
            label: 'company_details.general.vat_number_label',
            placeholder: 'company_details.general.vat_number_placeholder',
        },
        {
            type: 'text',
            name: 'iban_number',
            label: 'company_details.general.iban_number_label',
            placeholder: 'company_details.general.iban_number_placeholder',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default DivisionForm;
